































































import Vue, { PropType } from 'vue';
import FieldInput from '@/components/form/FieldInput.vue';
import { ICardFormData } from '@/types/auth/account';

export default Vue.extend({
  name: 'TheReplenishmentCardForm',
  components: { FieldInput },

  props: {
    formData: {
      type: Object as PropType<ICardFormData>,
      required: true,
    },
  },

  mounted() {
    this.form = { ...this.formData };
  },

  watch: {
    formData(newValue) {
      this.form = { ...newValue };
    },
  },

  methods: {
    changeForm() {
      this.$emit('changeForm', this.form);
    },
    inputFormName() {
      this.form['name'] = this.form['name'].toUpperCase()
      this.changeForm();
    }
  },

  data() {
    return {
      form: {
        number: '',
        name: '',
        date: '',
        cvc: '',
        zip: '',
      } as ICardFormData,
    };
  },
});
